export const font = {
  'weight-regular': '400',
  'weight-medium': '500',
  'weight-semibold': '600',
  'weight-bold': '700',

  'size-80': '48px',
  'size-70': '40px',
  'size-60': '32px',
  'size-50': '28px',
  'size-40': '24px',
  'size-30': '20px',
  'size-20': '18px',
  'size-10': '16px',
  'size-5': '14px',
  'size-2': '12px',
  'size-1': '10px',

  'line-height-80': '56px',
  'line-height-70': '48px',
  'line-height-60': '40px',
  'line-height-50': '32px',
  'line-height-40': '28px',
  'line-height-30': '24px',
  'line-height-20': '20px',
  'line-height-10': '16px',
  'line-height-5': '10px',

  'letter-normal': '0px',
  'letter-wide': '0.6px',

  'display1-weight': 'var(--font-weight-bold)',
  'display1-size': 'var(--font-size-80)',
  'display1-line-height': 'var(--font-line-height-80)',
  'display1-letter': 'var(--font-letter-normal)',

  'display2-weight': 'var(--font-weight-bold)',
  'display2-size': 'var(--font-size-70)',
  'display2-line-height': 'var(--font-line-height-70)',
  'display2-letter': 'var(--font-letter-normal)',

  'headline1-weight': 'var(--font-weight-semibold)',
  'headline1-size': 'var(--font-size-60)',
  'headline1-line-height': 'var(--font-line-height-70)',
  'headline1-letter': 'var(--font-letter-wide)',

  'headline2-weight': 'var(--font-weight-semibold)',
  'headline2-size': 'var(--font-size-50)',
  'headline2-line-height': 'var(--font-line-height-60)',
  'headline2-letter': 'var(--font-letter-normal)',

  'headline3-weight': 'var(--font-weight-semibold)',
  'headline3-size': 'var(--font-size-40)',
  'headline3-line-height': 'var(--font-line-height-50)',
  'headline3-letter': 'var(--font-letter-normal)',

  'headline4-weight': 'var(--font-weight-semibold)',
  'headline4-size': 'var(--font-size-30)',
  'headline4-line-height': 'var(--font-line-height-50)',
  'headline4-letter': 'var(--font-letter-normal)',

  'headline5-weight': 'var(--font-weight-semibold)',
  'headline5-size': 'var(--font-size-20)',
  'headline5-line-height': 'var(--font-line-height-40)',
  'headline5-letter': 'var(--font-letter-normal)',

  'headline6-weight': 'var(--font-weight-semibold)',
  'headline6-size': 'var(--font-size-10)',
  'headline6-line-height': 'var(--font-line-height-30)',
  'headline6-letter': 'var(--font-letter-normal)',

  'label1-weight': 'var(--font-weight-semibold)',
  'label1-size': 'var(--font-size-10)',
  'label1-line-height': 'var(--font-line-height-30)',
  'label1-letter': 'var(--font-letter-normal)',

  'label2-weight': 'var(--font-weight-semibold)',
  'label2-size': 'var(--font-size-5)',
  'label2-line-height': 'var(--font-line-height-20)',
  'label2-letter': 'var(--font-letter-normal)',

  'label3-weight': 'var(--font-weight-medium)',
  'label3-size': 'var(--font-size-5)',
  'label3-line-height': '20px',
  'label3-letter': 'var(--font-letter-normal)',

  'label4-weight': 'var(--font-weight-medium)',
  'label4-size': 'var(--font-size-1)',
  'label4-line-height': 'var(--font-line-height-5)',
  'label4-letter': 'var(--font-letter-normal)',

  'body1-weight': 'var(--font-weight-regular)',
  'body1-size': 'var(--font-size-30)',
  'body1-line-height': 'var(--font-line-height-50)',
  'body1-letter': 'var(--font-letter-normal)',

  'body2-weight': 'var(--font-weight-regular)',
  'body2-size': 'var(--font-size-20)',
  'body2-line-height': '28px',
  'body2-letter': 'var(--font-letter-normal)',

  'body3-weight': 'var(--font-weight-regular)',
  'body3-size': 'var(--font-size-10)',
  'body3-line-height': '24px',
  'body3-letter': 'var(--font-letter-normal)',

  'body4-weight': 'var(--font-weight-regular)',
  'body4-size': 'var(--font-size-5)',
  'body4-line-height': 'var(--font-line-height-20)',
  'body4-letter': 'var(--font-letter-normal)',

  'small-caption1-weight': 'var(--font-weight-regular)',
  'small-caption1-size': 'var(--font-size-2)',
  'small-caption1-line-height': 'var(--font-line-height-10)',
  'small-caption1-letter': 'var(--font-letter-normal)',

  'small-caption2-weight': 'var(--font-weight-medium)',
  'small-caption2-size': 'var(--font-size-2)',
  'small-caption2-line-height': 'var(--font-line-height-10)',
  'small-caption2-letter': 'var(--font-letter-normal)',

  'small-caption3-weight': 'var(--font-weight-semibold)',
  'small-caption3-size': 'var(--font-size-2)',
  'small-caption3-line-height': 'var(--font-line-height-10)',
  'small-caption3-letter': 'var(--font-letter-normal)',

  'button1-weight': 'var(--font-weight-bold)',
  'button1-size': 'var(--font-size-10)',
  'button1-line-height': 'var(--font-line-height-30)',
  'button1-letter': 'var(--font-letter-normal)',

  'button2-weight': 'var(--font-weight-bold)',
  'button2-size': 'var(--font-size-5)',
  'button2-line-height': 'var(--font-line-height-20)',
  'button2-letter': 'var(--font-letter-normal)',

  'button3-weight': 'var(--font-weight-semibold)',
  'button3-size': 'var(--font-size-5)',
  'button3-line-height': 'var(--font-line-height-20)',
  'button3-letter': 'var(--font-letter-normal)'
};
